"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonClose = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["onClick", "ariaLabel", "size"];
var sizeClasses = {
  sm: 'button-close_sm',
  md: 'button-close_md',
  auto: ''
};
var ButtonClose = exports.ButtonClose = function ButtonClose(_ref) {
  var onClick = _ref.onClick,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? 'Close' : _ref$ariaLabel,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'auto' : _ref$size,
    otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var buttonClasses = (0, _classnames["default"])('button-close', sizeClasses[size]);
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, otherProps, {
    type: "button",
    className: buttonClasses,
    onClick: onClick,
    "aria-label": ariaLabel
  }), /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m32 16c0-8.83655385-7.1634462-16-16-16-8.83655385 0-16 7.16344615-16 16 0 8.8365538 7.16344615 16 16 16 8.8365538 0 16-7.1634462 16-16zm-10.2066462-5.7933538c.4806154.4806153.4806154 1.2599384 0 1.7405538l-4.0528 4.0528 4.0528 4.0528c.4806154.4806154.4806154 1.2599385 0 1.7405538-.4806153.4806154-1.2599384.4806154-1.7405538 0l-4.0528-4.0528-4.0528 4.0528c-.4806154.4806154-1.2599385.4806154-1.7405538 0-.48061543-.4806153-.48061543-1.2599384 0-1.7405538l4.0528-4.0528-4.0528-4.0528c-.48061543-.4806154-.48061543-1.2599385 0-1.7405538.4806153-.48061543 1.2599384-.48061543 1.7405538 0l4.0528 4.0528 4.0528-4.0528c.4806154-.48061543 1.2599385-.48061543 1.7405538 0z"
  })));
};

// is only needed to avoid snapshots updating
ButtonClose.defaultProps = {
  onClick: null,
  ariaLabel: 'Close',
  size: 'auto'
};